/**
 * @generated SignedSource<<6a8e226a0dbbc5476615f31f419091b1>>
 * @relayHash 723e8ee9cb79e80b2192ef0affd3ada0
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/567.0.0-2026-07-09T16:56:40.579Z/BuyRespLayoutRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageDisplayEnum = "auctionsSearchAndBrowse" | "cart" | "catalog" | "checkout" | "email" | "favorites" | "homepage" | "mc" | "pdp" | "publication" | "searchAndBrowse" | "similarSold" | "visuallySimilar" | "%future added value";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type BuyRespLayoutRefetchQuery$variables = {
  afterDisplayOrBtSsr: boolean;
  categoryLevel?: number | null;
  fetchBuy: boolean;
  fetchRegionalInfo?: boolean | null;
  fetchTileVideo?: boolean | null;
  fetchUser: boolean;
  first: number;
  followSearchPages?: ReadonlyArray<string | null> | null;
  followSearchTypes?: ReadonlyArray<types | null> | null;
  guestId?: string | null;
  isClient: boolean;
  isTrade: boolean;
  localeOrigin: string;
  numOfItemsToInflate?: number | null;
  page: number;
  pageDisplayEnum?: PageDisplayEnum | null;
  personalizationId?: string | null;
  priceBookName?: string | null;
  regions?: string | null;
  rootId: string;
  showSeller: boolean;
  skipUser?: boolean | null;
  topItemIds?: ReadonlyArray<string | null> | null;
  uriRef: string;
  userCountryCode?: string | null;
  userId?: string | null;
  userZipCode?: string | null;
};
export type BuyRespLayoutRefetchQuery$data = {
  readonly viewer: {
    readonly buyPage?: {
      readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
          readonly displayName: string | null;
        } | null> | null;
      } | null> | null;
      readonly bottomModule: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"SharedBottomModule_bottomModule">;
      } | null> | null;
      readonly displayMaxNumberOfPages: number | null;
      readonly displayUriRef: string | null;
      readonly filters: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_filters">;
      } | null> | null;
      readonly internalBuyLinks: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_links">;
      } | null> | null;
      readonly totalResults: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_itemSearch" | "BuySharedAsyncModules_buyPage" | "BuySharedBreadcrumbs_buyPage" | "BuySharedDescription_buyPage" | "BuySharedHead_buyPage" | "BuySharedRefetchContainer_buyPage" | "BuySharedRelatedPages_buyPage" | "BuySharedResultContainer_buyPage" | "BuySharedTitle_buyPage" | "SharedFollowTopButton_itemSearch" | "SharedRespLinksBlock_itemSearch" | "SharedSaveSearchContext_itemSearch" | "SharedWordpressArticles_itemSearch">;
    } | null;
    readonly isWordpressArticlesEnabled: boolean | null;
    readonly user?: {
      readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_user" | "BuySharedAsyncModules_user" | "BuySharedResultContainer_user" | "SharedFollowSearchBanner_user" | "SharedFollowTopButton_user" | "SharedSaveSearchContext_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_viewer" | "BuySharedAsyncModules_viewer" | "BuySharedResultContainer_viewer">;
  };
};
export type BuyRespLayoutRefetchQuery = {
  response: BuyRespLayoutRefetchQuery$data;
  variables: BuyRespLayoutRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "afterDisplayOrBtSsr"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryLevel"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchBuy"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchTileVideo"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSearchPages"
},
v8 = {
  "defaultValue": [
    "SEARCH",
    "USER_PREFERENCE"
  ],
  "kind": "LocalArgument",
  "name": "followSearchTypes"
},
v9 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "guestId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "localeOrigin"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numOfItemsToInflate"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v15 = {
  "defaultValue": "searchAndBrowse",
  "kind": "LocalArgument",
  "name": "pageDisplayEnum"
},
v16 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "personalizationId"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v18 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "regions"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rootId"
},
v20 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showSeller"
},
v21 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skipUser"
},
v22 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "topItemIds"
},
v23 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uriRef"
},
v24 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v25 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v26 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v27 = {
  "alias": "isWordpressArticlesEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "featureName",
      "value": "WP_EDITORIAL"
    }
  ],
  "kind": "ScalarField",
  "name": "isEnabledByLocale",
  "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
},
v28 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v29 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v30 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v31 = [
  {
    "kind": "Variable",
    "name": "buyPageId",
    "variableName": "rootId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "guestId",
    "variableName": "guestId"
  },
  {
    "kind": "Variable",
    "name": "localeOrigin",
    "variableName": "localeOrigin"
  },
  {
    "kind": "Variable",
    "name": "numOfItemsToInflate",
    "variableName": "numOfItemsToInflate"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  (v28/*:: as any*/),
  {
    "kind": "Variable",
    "name": "regions",
    "variableName": "regions"
  },
  (v29/*:: as any*/),
  (v30/*:: as any*/),
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "personalizationId"
  }
],
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayMaxNumberOfPages",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUriRef",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v37 = [
  (v36/*:: as any*/)
],
v38 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkReference",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mm",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "us",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedFilterName",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medianL3SoldItemPriceScore",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regionName",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplimentary",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCalculated",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "totalAmount",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmounts",
      "kind": "LinkedField",
      "name": "convertedAmounts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "USD",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v61 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  },
  (v49/*:: as any*/)
],
v62 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": (v61/*:: as any*/),
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountType",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v65 = {
  "alias": "displayPriceTracking",
  "args": [
    {
      "kind": "Literal",
      "name": "catchNonFatalErrors",
      "value": false
    },
    (v60/*:: as any*/),
    {
      "kind": "Variable",
      "name": "page",
      "variableName": "pageDisplayEnum"
    },
    (v28/*:: as any*/),
    (v30/*:: as any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v62/*:: as any*/),
    (v63/*:: as any*/),
    (v64/*:: as any*/)
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "englishCountryName",
      "storageKey": null
    },
    (v40/*:: as any*/)
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contemporaryTrackingString",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNewListing",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "addLabel",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height",
            "width",
            "depth",
            "diameter",
            "length"
          ]
        },
        {
          "kind": "Literal",
          "name": "separator",
          "value": " "
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unit",
          "storageKey": null
        },
        (v73/*:: as any*/)
      ],
      "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSize",
      "kind": "LinkedField",
      "name": "size",
      "plural": false,
      "selections": [
        (v73/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Creator",
      "kind": "LinkedField",
      "name": "creator",
      "plural": false,
      "selections": [
        (v36/*:: as any*/),
        (v40/*:: as any*/)
      ],
      "storageKey": null
    },
    (v40/*:: as any*/)
  ],
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v78/*:: as any*/),
    (v79/*:: as any*/)
  ],
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v53/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v53/*:: as any*/),
                (v36/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imageUrl",
                  "storageKey": null
                },
                (v40/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v40/*:: as any*/)
  ],
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": [
    (v60/*:: as any*/),
    {
      "kind": "Literal",
      "name": "page",
      "value": "searchAndBrowse"
    },
    (v28/*:: as any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": [
    (v62/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "originalConvertedAmountList",
      "plural": true,
      "selections": (v61/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quantityDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentageOff",
      "storageKey": null
    },
    (v64/*:: as any*/),
    (v63/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceLabel",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "showPriceVariability",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewParagraph",
      "kind": "LinkedField",
      "name": "paragraphs",
      "plural": true,
      "selections": [
        (v48/*:: as any*/),
        (v85/*:: as any*/),
        {
          "alias": "mobileText",
          "args": [
            {
              "kind": "Literal",
              "name": "formatType",
              "value": "MOBILE"
            }
          ],
          "kind": "ScalarField",
          "name": "text",
          "storageKey": "text(formatType:\"MOBILE\")"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCreator",
      "kind": "LinkedField",
      "name": "creators",
      "plural": true,
      "selections": [
        (v36/*:: as any*/),
        (v80/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewCategorySegments",
      "kind": "LinkedField",
      "name": "paragraphAttributeNames",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "period",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "origin",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "style",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "periodPrefix",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallPath",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webPath",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v89 = {
  "alias": "carouselPhotos",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 2
    }
  ],
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "masterOrZoomPath",
      "storageKey": null
    },
    (v87/*:: as any*/),
    (v88/*:: as any*/),
    (v40/*:: as any*/)
  ],
  "storageKey": "photos(limit:2)"
},
v90 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v91 = {
  "alias": "productPhotos",
  "args": (v90/*:: as any*/),
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    (v87/*:: as any*/),
    (v88/*:: as any*/),
    (v40/*:: as any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v92 = {
  "condition": "showSeller",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerProfile",
          "kind": "LinkedField",
          "name": "sellerProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "company",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorText",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchTerm",
  "storageKey": null
},
v95 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 28
  }
],
v96 = [
  (v53/*:: as any*/),
  (v55/*:: as any*/),
  (v50/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "Seller",
    "kind": "LinkedField",
    "name": "seller",
    "plural": false,
    "selections": [
      (v53/*:: as any*/),
      (v40/*:: as any*/)
    ],
    "storageKey": null
  },
  (v65/*:: as any*/),
  (v66/*:: as any*/),
  (v54/*:: as any*/),
  (v67/*:: as any*/),
  (v68/*:: as any*/),
  (v69/*:: as any*/),
  (v70/*:: as any*/),
  (v71/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "ShipmentQuote",
    "kind": "LinkedField",
    "name": "shipmentQuotes",
    "plural": true,
    "selections": [
      (v57/*:: as any*/),
      (v58/*:: as any*/),
      (v59/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "ShipmentServiceMethod",
        "kind": "LinkedField",
        "name": "serviceMethod",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Region",
            "kind": "LinkedField",
            "name": "region",
            "plural": false,
            "selections": [
              (v56/*:: as any*/),
              (v40/*:: as any*/)
            ],
            "storageKey": null
          },
          (v40/*:: as any*/)
        ],
        "storageKey": null
      },
      (v40/*:: as any*/)
    ],
    "storageKey": null
  },
  (v72/*:: as any*/),
  (v74/*:: as any*/),
  (v75/*:: as any*/),
  (v76/*:: as any*/),
  (v77/*:: as any*/),
  (v80/*:: as any*/),
  (v81/*:: as any*/),
  (v82/*:: as any*/),
  (v83/*:: as any*/),
  (v84/*:: as any*/),
  (v86/*:: as any*/),
  (v89/*:: as any*/),
  (v91/*:: as any*/),
  (v40/*:: as any*/),
  (v92/*:: as any*/)
],
v97 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ItemSearchResult",
    "kind": "LinkedField",
    "name": "node",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Item",
        "kind": "LinkedField",
        "name": "item",
        "plural": false,
        "selections": (v96/*:: as any*/),
        "storageKey": null
      },
      (v40/*:: as any*/)
    ],
    "storageKey": null
  }
],
v98 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v99 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "zipCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  },
  (v40/*:: as any*/)
],
v100 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "followSearchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "followSearchTypes"
  }
],
v101 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v102 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/),
      (v5/*:: as any*/),
      (v6/*:: as any*/),
      (v7/*:: as any*/),
      (v8/*:: as any*/),
      (v9/*:: as any*/),
      (v10/*:: as any*/),
      (v11/*:: as any*/),
      (v12/*:: as any*/),
      (v13/*:: as any*/),
      (v14/*:: as any*/),
      (v15/*:: as any*/),
      (v16/*:: as any*/),
      (v17/*:: as any*/),
      (v18/*:: as any*/),
      (v19/*:: as any*/),
      (v20/*:: as any*/),
      (v21/*:: as any*/),
      (v22/*:: as any*/),
      (v23/*:: as any*/),
      (v24/*:: as any*/),
      (v25/*:: as any*/),
      (v26/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BuyRespLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v27/*:: as any*/),
          {
            "condition": "fetchBuy",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "buyPage",
                "args": (v31/*:: as any*/),
                "concreteType": "ItemSearchQueryConnection",
                "kind": "LinkedField",
                "name": "itemSearch",
                "plural": false,
                "selections": [
                  (v32/*:: as any*/),
                  (v33/*:: as any*/),
                  (v34/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParam",
                    "kind": "LinkedField",
                    "name": "appliedFilters",
                    "plural": true,
                    "selections": [
                      (v35/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": (v37/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilter",
                    "kind": "LinkedField",
                    "name": "filters",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BuyRespRefineMenu_filters"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BottomModule",
                    "kind": "LinkedField",
                    "name": "bottomModule",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedBottomModule_bottomModule"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedRefetchContainer_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedBreadcrumbs_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedTitle_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedRelatedPages_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedResultContainer_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedAsyncModules_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedDescription_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedHead_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SharedWordpressArticles_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SharedRespLinksBlock_itemSearch"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "kind": "LinkedField",
                    "name": "internalBuyLinks",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedRespLinksBlock_links"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuyRespRefineMenu_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SharedSaveSearchContext_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SharedFollowTopButton_itemSearch"
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "skipUser",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v38/*:: as any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BuyRespRefineMenu_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BuySharedResultContainer_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BuySharedAsyncModules_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedSaveSearchContext_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedFollowTopButton_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedFollowSearchBanner_user"
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuySharedAsyncModules_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuyRespRefineMenu_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuySharedResultContainer_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v23/*:: as any*/),
      (v12/*:: as any*/),
      (v10/*:: as any*/),
      (v0/*:: as any*/),
      (v11/*:: as any*/),
      (v20/*:: as any*/),
      (v6/*:: as any*/),
      (v14/*:: as any*/),
      (v19/*:: as any*/),
      (v2/*:: as any*/),
      (v26/*:: as any*/),
      (v24/*:: as any*/),
      (v3/*:: as any*/),
      (v25/*:: as any*/),
      (v16/*:: as any*/),
      (v9/*:: as any*/),
      (v5/*:: as any*/),
      (v21/*:: as any*/),
      (v8/*:: as any*/),
      (v7/*:: as any*/),
      (v17/*:: as any*/),
      (v18/*:: as any*/),
      (v15/*:: as any*/),
      (v4/*:: as any*/),
      (v13/*:: as any*/),
      (v22/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "BuyRespLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v27/*:: as any*/),
          {
            "alias": "vimeoItemsVideoHLSPlayerFF",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "vimeoItemsVideoHLSPlayer"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"vimeoItemsVideoHLSPlayer\")"
          },
          {
            "alias": "video",
            "args": null,
            "concreteType": "ItemVideo",
            "kind": "LinkedField",
            "name": "itemVideoV2",
            "plural": false,
            "selections": [
              (v39/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vimeoUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "videoProvider",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "sbBatchLazyLoadFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "feature",
                "value": "sbBatchLazyLoad"
              }
            ],
            "kind": "ScalarField",
            "name": "featureFlag",
            "storageKey": "featureFlag(feature:\"sbBatchLazyLoad\")"
          },
          (v40/*:: as any*/),
          {
            "condition": "fetchBuy",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "buyPage",
                "args": (v31/*:: as any*/),
                "concreteType": "ItemSearchQueryConnection",
                "kind": "LinkedField",
                "name": "itemSearch",
                "plural": false,
                "selections": [
                  (v32/*:: as any*/),
                  (v33/*:: as any*/),
                  (v34/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParam",
                    "kind": "LinkedField",
                    "name": "appliedFilters",
                    "plural": true,
                    "selections": [
                      (v35/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v36/*:: as any*/),
                          (v41/*:: as any*/),
                          (v42/*:: as any*/),
                          (v43/*:: as any*/),
                          (v44/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FilterPropertiesType",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                              (v45/*:: as any*/),
                              (v46/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canBeDismissed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clearAllLinkReference",
                        "storageKey": null
                      },
                      (v47/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilter",
                    "kind": "LinkedField",
                    "name": "filters",
                    "plural": true,
                    "selections": [
                      (v35/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      },
                      (v47/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "originalFilterName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseFilterValue",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v44/*:: as any*/),
                          (v36/*:: as any*/),
                          (v43/*:: as any*/),
                          (v41/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "stats",
                            "kind": "LinkedField",
                            "name": "stats",
                            "plural": true,
                            "selections": [
                              (v48/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "values",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hexCode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FilterPropertiesType",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                              (v45/*:: as any*/),
                              (v46/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "min",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "max",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v42/*:: as any*/),
                          (v49/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BottomModule",
                    "kind": "LinkedField",
                    "name": "bottomModule",
                    "plural": true,
                    "selections": [
                      (v50/*:: as any*/),
                      (v51/*:: as any*/),
                      (v52/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "trackedAbTests",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pageType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SortType",
                    "kind": "LinkedField",
                    "name": "sort",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortCurrentOption",
                        "kind": "LinkedField",
                        "name": "currentOption",
                        "plural": false,
                        "selections": [
                          (v41/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbTestConfigV2UserVariant",
                    "kind": "LinkedField",
                    "name": "seoAbTestV2List",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "variant",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbTestConfigV2",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "testName",
                            "storageKey": null
                          },
                          (v40/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSearchResult",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              (v53/*:: as any*/),
                              (v40/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isPartialItem",
                                "storageKey": null
                              },
                              (v54/*:: as any*/),
                              (v55/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isOnHold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isSold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isUnavailable",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Seller",
                                "kind": "LinkedField",
                                "name": "seller",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isAccessible",
                                    "storageKey": null
                                  },
                                  (v40/*:: as any*/),
                                  (v53/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ShipmentQuote",
                                "kind": "LinkedField",
                                "name": "shipmentQuotes",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ShipmentServiceMethod",
                                    "kind": "LinkedField",
                                    "name": "serviceMethod",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Region",
                                        "kind": "LinkedField",
                                        "name": "region",
                                        "plural": false,
                                        "selections": [
                                          (v42/*:: as any*/),
                                          (v40/*:: as any*/),
                                          (v56/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v40/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v40/*:: as any*/),
                                  (v57/*:: as any*/),
                                  (v58/*:: as any*/),
                                  (v59/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              (v50/*:: as any*/),
                              (v65/*:: as any*/),
                              (v66/*:: as any*/),
                              (v67/*:: as any*/),
                              (v68/*:: as any*/),
                              (v69/*:: as any*/),
                              (v70/*:: as any*/),
                              (v71/*:: as any*/),
                              (v72/*:: as any*/),
                              (v74/*:: as any*/),
                              (v75/*:: as any*/),
                              (v76/*:: as any*/),
                              (v77/*:: as any*/),
                              (v80/*:: as any*/),
                              (v81/*:: as any*/),
                              (v82/*:: as any*/),
                              (v83/*:: as any*/),
                              (v84/*:: as any*/),
                              (v86/*:: as any*/),
                              (v89/*:: as any*/),
                              (v91/*:: as any*/),
                              {
                                "alias": null,
                                "args": (v90/*:: as any*/),
                                "concreteType": "ItemPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                  (v88/*:: as any*/),
                                  (v40/*:: as any*/)
                                ],
                                "storageKey": "photos(limit:1)"
                              },
                              (v92/*:: as any*/),
                              {
                                "condition": "fetchTileVideo",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasApprovedVideo",
                                    "storageKey": null
                                  }
                                ]
                              }
                            ],
                            "storageKey": null
                          },
                          (v40/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v85/*:: as any*/),
                      (v78/*:: as any*/),
                      (v79/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MetaData",
                    "kind": "LinkedField",
                    "name": "meta",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "header",
                        "storageKey": null
                      },
                      (v50/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "topQueries",
                        "storageKey": null
                      },
                      (v51/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canonical",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "disableIndexing",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "microdata",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "next",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "prev",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LanguageAnnotations",
                        "kind": "LinkedField",
                        "name": "languageAnnotations",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "href",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hrefLang",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "kind": "LinkedField",
                    "name": "relatedBuyPages",
                    "plural": true,
                    "selections": [
                      (v93/*:: as any*/),
                      (v39/*:: as any*/),
                      (v40/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "popularSearchesLink",
                    "plural": false,
                    "selections": [
                      (v85/*:: as any*/),
                      (v78/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v94/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "searchRequestId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchSponsored",
                    "kind": "LinkedField",
                    "name": "sponsored",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxAvailable",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSearchSponsoredMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "itemId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "impressionTrackerLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "clickTrackerLink",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchCorrectionsType",
                    "kind": "LinkedField",
                    "name": "searchCorrections",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "classificationSearchTerm",
                        "storageKey": null
                      },
                      (v94/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "semanticSearchTerm",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "soldItemResults",
                    "args": (v95/*:: as any*/),
                    "concreteType": "soldResultsConnection",
                    "kind": "LinkedField",
                    "name": "soldResults",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "soldResultsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v97/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": "soldResults(first:28)"
                  },
                  {
                    "alias": null,
                    "args": (v98/*:: as any*/),
                    "concreteType": "youMayAlsoLikeConnection",
                    "kind": "LinkedField",
                    "name": "youMayAlsoLike",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "youMayAlsoLikeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v97/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": "youMayAlsoLike(first:20)"
                  },
                  {
                    "alias": null,
                    "args": (v95/*:: as any*/),
                    "concreteType": "personalizedSearchItemsConnection",
                    "kind": "LinkedField",
                    "name": "personalizedSearchItems",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "personalizedSearchItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": (v97/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": "personalizedSearchItems(first:28)"
                  },
                  (v51/*:: as any*/),
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 8
                      }
                    ],
                    "concreteType": "WordpressArticlesType",
                    "kind": "LinkedField",
                    "name": "editorialArticles",
                    "plural": false,
                    "selections": [
                      (v32/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WordpressArticleType",
                        "kind": "LinkedField",
                        "name": "articles",
                        "plural": true,
                        "selections": [
                          (v50/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WordpressArticleImageType",
                            "kind": "LinkedField",
                            "name": "imageUrl",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "full",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subtitle",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "link",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "source",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "editorialArticles(first:8)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "kind": "LinkedField",
                    "name": "internalBuyLinks",
                    "plural": true,
                    "selections": [
                      (v39/*:: as any*/),
                      (v93/*:: as any*/),
                      (v40/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "topCategoryL1",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAttributePage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canFollowSearch",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "isRewarded",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "listNames",
                            "value": [
                              "SELLER_REWARDS_1",
                              "SELLER_REWARDS_2"
                            ]
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "isAnchorListsMember",
                        "storageKey": "isAnchorListsMember(listNames:[\"SELLER_REWARDS_1\",\"SELLER_REWARDS_2\"])"
                      },
                      (v40/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v40/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "skipUser",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v38/*:: as any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isVerifiedTrade",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserPreferences",
                        "kind": "LinkedField",
                        "name": "preferences",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "measurementUnit",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v53/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AddressBook",
                        "kind": "LinkedField",
                        "name": "addressBook",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "personalAddress",
                            "plural": false,
                            "selections": (v99/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "proAddress",
                            "plural": false,
                            "selections": (v99/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "addressList",
                            "plural": true,
                            "selections": (v99/*:: as any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "showStrategicPartnerFilter",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "STRATEGIC_PARTNER_FILTERING"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasPermission",
                        "storageKey": "hasPermission(name:\"STRATEGIC_PARTNER_FILTERING\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canShowFolder",
                        "storageKey": null
                      },
                      {
                        "condition": "showSeller",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "canShowSellerName",
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "alias": "canShowStorefrontOnlyBadge",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "VIEW_STOREFRONT_ONLY_BADGE"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasPermission",
                        "storageKey": "hasPermission(name:\"VIEW_STOREFRONT_ONLY_BADGE\")"
                      },
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v100/*:: as any*/),
                            "concreteType": "favoritesConnection",
                            "kind": "LinkedField",
                            "name": "favorites",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "favoritesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Favorite",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v53/*:: as any*/),
                                      (v36/*:: as any*/),
                                      (v40/*:: as any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__id",
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v52/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v100/*:: as any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "SharedSaveSearchContext_favorites",
                            "kind": "LinkedHandle",
                            "name": "favorites"
                          }
                        ]
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParentProgram",
                                "kind": "LinkedField",
                                "name": "currentProgram",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "programInfo",
                                    "plural": false,
                                    "selections": [
                                      (v42/*:: as any*/),
                                      (v40/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v40/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v40/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "condition": "afterDisplayOrBtSsr",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v29/*:: as any*/)
                ],
                "concreteType": "BuyPageSoldResults",
                "kind": "LinkedField",
                "name": "buyPageSoldResults",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v95/*:: as any*/),
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": (v96/*:: as any*/),
                    "storageKey": "items(first:28)"
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "categoryLevel",
                    "variableName": "categoryLevel"
                  },
                  {
                    "kind": "Variable",
                    "name": "topItemIds",
                    "variableName": "topItemIds"
                  },
                  (v29/*:: as any*/)
                ],
                "concreteType": "BuyPageItemRecommendations",
                "kind": "LinkedField",
                "name": "buyPageItemRecommendations",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v98/*:: as any*/),
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "youMayAlsoLike",
                    "plural": true,
                    "selections": (v96/*:: as any*/),
                    "storageKey": "youMayAlsoLike(first:20)"
                  },
                  {
                    "alias": null,
                    "args": (v95/*:: as any*/),
                    "concreteType": "Item",
                    "kind": "LinkedField",
                    "name": "personalizationSearchItems",
                    "plural": true,
                    "selections": (v96/*:: as any*/),
                    "storageKey": "personalizationSearchItems(first:28)"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "locations",
                "args": [
                  (v101/*:: as any*/),
                  {
                    "kind": "Literal",
                    "name": "facetLimit",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "facetName",
                    "value": "location"
                  },
                  (v29/*:: as any*/),
                  (v102/*:: as any*/)
                ],
                "concreteType": "ItemFacetsQueryConnection",
                "kind": "LinkedField",
                "name": "itemFacetSearch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemFacetsQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v44/*:: as any*/),
                          (v36/*:: as any*/),
                          (v41/*:: as any*/),
                          (v43/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchRegionalInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v101/*:: as any*/),
                  (v102/*:: as any*/)
                ],
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RegionsByZipCode",
                    "kind": "LinkedField",
                    "name": "regionsByZipCode",
                    "plural": true,
                    "selections": (v37/*:: as any*/),
                    "storageKey": null
                  },
                  (v40/*:: as any*/)
                ],
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/567.0.0-2026-07-09T16:56:40.579Z/BuyRespLayoutRefetchQuery",
    "metadata": {},
    "name": "BuyRespLayoutRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5ea9541d538a096e3a66d4856d4351bd";

export default node;
